import styled from "styled-components";

export const ButtonListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;